import React from 'react'
import Button from 'components/controls/button'
import { Position, Tooltip } from "@blueprintjs/core"
import ContactPrefernecesModal from 'components/userManagement/contact-prefernces-modal'
import 'less/tables.less'

const Table = (props) => {
    return (
        <table >
            <tbody>
                <tr className='title'>
                    <td>Name</td>
                    <td>Email</td>
                    <td>User Types</td>
                    <td>Allow Contact By Email </td>
                    <td className='edit-user'> </td>
                </tr>
                {props.usersDetails && props.usersDetails.map((val, key) => {
                    return (
                        <tr key={key} className='table-elements'>
                            <td>{val.firstName} {val.lastName}</td>
                            <td>{val.email}</td>
                            <td>{val.userRole === 1 ? props.t('qs.moderator') : val.userRole === 2 ? props.t('qs.pm') : props.t('qs.admin')}</td>
                            <td>{val.allow_contact_by_email ? "Yes" : "No"}</td>
                            <td>
                                <div className='edit-user-button'>
                                    <Tooltip popoverClassName={"edit-user-tooltip"}
                                        content={props.t('edit.user.tooltip.message')}
                                        position={Position.BOTTOM}
                                        className='edit-user-tooltip'
                                    >
                                        <Button className="edit-user-btn btn-primary" onClick={() => props.openContactPreferencesModal(val.cognitoUserId)}>
                                            <i className='im-edit' />
                                        </Button>
                                    </Tooltip>
                                </div></td>
                        </tr>
                    )
                })}
            </tbody>
            {props.contactPreferencesModal.isOpen && <ContactPrefernecesModal
                isOpen={props.contactPreferencesModal.isOpen}
                onClose={props.closeContactPreferencesModal}
                isSubmitting={props.isUpdating}
                t={props.t}
                userId={props.contactPreferencesModal.userId}
                updateAllowContactByEmail={props.updateAllowContactByEmail}
                formatDate={props.formatDate}
                pmUser = {props.pmUser}
                showSnackbarMessageError = {props.showSnackbarMessageError}
                hideSnackbarMessage = {props.hideSnackbarMessage}
            />}
        </table>
    )
}

export default Table
